<template>
  <v-dialog v-model="dialogState" max-width="800" persistent>
    <v-card>

      <v-toolbar
        color="primary"
        flat
        short
      >
        <v-toolbar-title>{{ $t(this.masterFileType.display_name_singular) }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="hideDialog" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form
          autocomplete="off"
          @submit="function(e){saveItem();e.preventDefault()}"
        >
          <v-container class="mt-5">
            <v-row>

              <v-col v-if="masterFileType.is_translatable" cols="6" sm="6">
                <v-text-field
                  v-for="language in languages"
                  v-model="model.values[language.code]"
                  :key="language.code"
                  :label="$t('Name') + ' ( '+ language.description +' ) '"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col v-else cols="6" sm="6">
                <v-text-field
                  v-model="model.value"
                  :error-messages="errors.value"
                  :label="$t('Name')"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

            </v-row>
          </v-container>

        </v-form>
      </v-card-text>

      <v-card-actions class="px-10 pb-10">
        <v-btn color="warning" @click="deleteItem" v-if="!isNewItem" :disable="!model.is_deletable" :class="{ 'v-btn-disabled': !model.is_deletable }">{{ $t('Delete') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveItem">{{ isNewItem ? $t('Create') : $t('Save') }}</v-btn>
        <v-btn color="default" @click="hideDialog">{{ $t('Cancel') }}</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from '@/services/api.service'

export default {
  props: {
    'masterFileTypeTag': String,
  },
  data () {
    return {
      dialogState: false,
      deliveryDateDialog: false,

      model: {
        id: null,
        master_file_type_id: null,
        value: null,
        values: {},
      },
      masterFileType: {},
      errors: {},
    }
  },
  watch: {

  },
  computed: {
    isNewItem() {
      return !this.model.id
    },
    languages() {
        return this.$store.getters['language/getList']
    },
  },
  created() {
  },
  methods: {
    showDialog(id = null, masterFileType = null) {
      if (id !== null) {
        this.fetchItem(id)
      }
      this.dialogState = true
      this.masterFileType = masterFileType
    },
    hideDialog() {
      this.dialogState = false
      this.model = {
        values: {},
      }
    },
    getItem() {
      const item = this.model
      return item
    },
    fetchItem(id) {
      this.$store.dispatch('session/showLoader')
      this.errors = {}
      ApiService.view(`/master-files/${id}`, {
        params: {
        },
      }).then(item => {
        this.model = item
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    saveItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
      if (this.model.id) {
        ApiService.update(`/master-files/${this.model.id}`, {
          ...this.getItem(),
        }).then(item => {
          this.$emit('update', item)
          this.hideDialog()
        }).catch(errors => {
          this.errors = errors
        }).finally(() => {
          this.$store.dispatch('session/hideLoader')
        })
      } else {
        ApiService.create('/master-files', {
          ...this.getItem(),
          'system_tag': this.masterFileTypeTag,
        }).then(item => {
          this.$emit('update', item)
          this.hideDialog()
        }).catch(errors => {
          this.errors = errors
        }).finally(() => {
          this.$store.dispatch('session/hideLoader')
        })
      }
    },
    deleteItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')

      ApiService.delete(`/master-files/${this.model.id}`)
      .then(item => {
        this.$emit('update', item)
        this.hideDialog()
      }).catch(errors => {
        this.errors = errors
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
  },
}
</script>

<style scoped>
.v-btn-disabled {
    background-color: #bbb !important;
    color: #777 !important;
}
</style>

